type GetDynatraceTag = () => Promise<{ data: string }> | undefined;
type InjectDynatraceTag = (
	scriptText: string,
	onLoad: () => void,
	onError: (error?: unknown) => void
) => void;

export function createDynatraceInitializer() {
	let initialization: Promise<void> | undefined;

	return (getTag: GetDynatraceTag, injectTag: InjectDynatraceTag): Promise<void> | undefined => {
		if (!initialization) {
			const tagRequest = getTag();
			if (!tagRequest) {
				return undefined;
			}

			initialization = tagRequest
				.then((response) => new Promise<void>((resolve, reject) => {
					injectTag(response.data, resolve, reject);
				}))
				.catch((error) => {
					initialization = undefined;
					throw error;
				});
		}

		return initialization;
	};
}

/**
 * Tags the current Dynatrace RUM session with the logged-in user name.
 * Returns false when the agent is not loaded yet or there is no user to tag.
 */
export function identifyDynatraceUser(userName: string | undefined): boolean {
	if (!userName || typeof window === 'undefined' || !window.dtrum) {
		return false;
	}
	window.dtrum.identifyUser(userName);
	return true;
}

/** Ends the current RUM session so activity after logout is not attributed to the previous user. */
export function endDynatraceSession(): boolean {
	if (typeof window === 'undefined' || !window.dtrum) {
		return false;
	}
	window.dtrum.endSession();
	return true;
}